module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Angel Prayer 2")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Stay by me, angel,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("uphold me,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("that my feet don’t slip.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Beloved child ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of God’s bloodied heart,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("anoint my wounds ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("with unction ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of your healing balm. ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Yours the love")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("that welcomes grief,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("turning tears")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("to silent alleluias")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of the quickened soul.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Touch me,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("that I may sing them")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("heavenly and resounding ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("as the angel-voices ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("that I hear.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Change me")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("from the wounder")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("(or the wounded)")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("to one who")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("offers salve")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("like yours, of love,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("for every broken")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("thou.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fe62a37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-6.vue
// module id = 75
// module chunks = 0